import { PlayerAiSummaryFilterParams } from '@/atoms/queries/player/playerAiSummaryFilters';
import { PlayerSummaryData } from '@/hooks/usePlayerFilteredSummaryData';
import { isNullish } from '@/utils/predicates';
import type { ProfileInfo } from '@statsbomb/kitbag-ai-summary';

// The AI summary's playerData, shared by the player dashboard and the scout preview so the two can't drift.
export const buildPlayerData = (
  playerId: number,
  summaryData: PlayerSummaryData,
  filterParams: PlayerAiSummaryFilterParams,
  profileInfo: ProfileInfo,
) => ({
  playerId: String(playerId),
  metrics: summaryData.metrics,
  minutesPlayed: summaryData.minutesPlayed,
  primaryPosition: summaryData.primaryPosition,
  positions: summaryData.positions,
  ...(!isNullish(summaryData.cohortSize) ? { cohortSize: summaryData.cohortSize } : {}),
  competitionInfos: filterParams.competitionInfos.map(({ id, name, country }) => ({
    id: String(id),
    name,
    country,
  })),
  seasonInfos: filterParams.seasonInfos.map(({ id, name }) => ({
    id: String(id),
    name,
  })),
  profileInfo,
});
